import { brandColor, brandLogo } from './brands';

// Item metadata sources. `short` is the badge spelling, given only where the
// full name is too long for one.
// CuratedList is the platform itself, AI is a reader of the page, web and
// schema are the page speaking for itself - none of them has a brand behind it.
const SOURCES = {
  cl: { name: 'CuratedList' },
  ai: { name: 'AI' },
  web: { name: 'Meta tags' },
  schema: { name: 'schema.org' },
  hn: { name: 'Hacker News', short: 'HN', brand: 'hackernews' },
  lb: { name: 'Lobsters', brand: 'lobsters' },
  rd: { name: 'Reddit', brand: 'reddit' },
  gh: { name: 'GitHub', brand: 'github' },
  yt: { name: 'YouTube', brand: 'youtube' },
  tw: { name: 'X / Twitter', short: 'X', brand: 'x' },
};

export function sourceName(key) {
  return SOURCES[key]?.name || key;
}

export function sourceShortName(key) {
  return SOURCES[key]?.short || SOURCES[key]?.name || key;
}

export function sourceLogo(key) {
  const brand = SOURCES[key]?.brand;
  return brand ? brandLogo(brand) : null;
}

export function sourceColor(key) {
  const brand = SOURCES[key]?.brand;
  return brand ? brandColor(brand) : null;
}
